export default {
	oidc: {
	  issuer: document.URL.indexOf("localhost") > 0 || document.URL.indexOf("test") > 0 ? 'https://osk.oktapreview.com/oauth2/default' : 'https://osk.okta.com/oauth2/default',
	  clientId: document.URL.indexOf("localhost") > 0 || document.URL.indexOf("test") > 0 ? '0oalemfx6sK6XQHFR1d7' : '0oaqp69xn6pZfpIe0697',
	  redirectUri: `${window.location.origin}/login/callback`,
	  scopes: ['openid', 'profile', 'offline_access', 'email'],
	  pkce: true
	}
};